import { Location } from 'history';
import { parse, stringify } from 'qs';

type Query = Record<string, string | object | null | void>;

const mergeUrlQuery = (location: Location, query: Query) => {
  const oldQuery = parse(location.search.slice(1));
  const merged = { ...oldQuery, ...query };

  return { ...location, search: `?${stringify(merged, { skipNulls: true })}` };
};

export default mergeUrlQuery;
